import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { DatasetMultiSelect } from "components/basic/dropdowns/dataset/DatasetMultiSelect";
import { Button } from "primereact/button";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { handleRowReorder, handleRowReorderEvt } from "utils/utils";

interface Chart {
  identifiers?: string[];
  chartName?: string;
}

interface DataTableProps {
  charts: Chart[];
  onDataUpdate: (updatedData: Chart[]) => void;
  selectedDatasets: string[];
  handleDatasetChange: (rowIndex: number, selectedDatasets: string[]) => void;
  handleAddChart: () => void;
}

const DataTableComponent: React.FC<DataTableProps> = ({
  charts,
  onDataUpdate,
  handleDatasetChange,
  handleAddChart,
}) => {
  const [data, setData] = useState<Chart[]>([]);
 

  useEffect(() => {
    setData(charts);
  }, [charts]);

  const renderNames = (rowData: Chart) => {
    return <span>{rowData.chartName}</span>;
  };

  const renderIdentifiers = (rowData: Chart) => {
    return (
      <div className="p-0">
        {rowData.identifiers?.map((identifier, index) => (
          <DatasetTitle key={index} identifier={identifier} />
        ))}
      </div>
    );
  };

  const onRowEditComplete = (e: any): void => {
    const updatedData = [...data];
    let { index } = e;
    updatedData[index].identifiers = e.data.identifiers;
    updatedData[index].chartName = e.newData.chartName;
    setData(updatedData);
    onDataUpdate(updatedData);
  };

  const textEditor = (options: any) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };
  const textEditorForIdentifiers = (options: any, rowIndex: number) => {
    return (
      <div className="flex gap-2">
        <DatasetMultiSelect
          value={options.value}
          onChange={(selectedIdentifiers: string[]) =>
            handleDatasetChange(rowIndex, selectedIdentifiers)
          }
        />
      </div>
    );
  };

  const handleDeleteChart = (rowData: Chart): void => {
    const updatedData = data.filter((item) => item !== rowData);
    setData(updatedData);
    onDataUpdate(updatedData);
  };
  const tableHeader = () => {
    return (
      <div className="flex w-full justify-content-end">
        <Button
          type="button"
          icon="pi pi-plus"
          tooltip="Add group or dataset"
          className="p-button-rounded p-button-success p-button-text p-ml-2"
          style={{ fontSize: "0.8rem" }}
          onClick={() => handleAddChart()}
        />
      </div>
    );
  };

  return (
    <div className="card p-fluid w-full">
      <h5>Charts</h5>
      <DataTable
        header={tableHeader}
        className="overflow-scroll"
        scrollHeight="300px"
        value={data}
        editMode="row"
        dataKey="id"
        onRowEditComplete={onRowEditComplete}
        responsiveLayout="scroll"
        size="small"
        onRowReorder={handleRowReorderEvt(data, onDataUpdate, undefined, undefined)}
        reorderableRows
    >
        <Column rowReorder style={{width: "3%"}}/>
        <Column
          field="chartName"
          editor={(options) => textEditor(options)}
          header="Chart Name"
          body={renderNames}
          style={{ width: "20%" }}
        />
        <Column
          field="identifiers"
          header="Titles"
          headerStyle={{ paddingLeft: "1rem" }}
          editor={(options) =>
            textEditorForIdentifiers(options, options.rowIndex)
          }
          body={renderIdentifiers}
        />

        <Column rowEditor style={{ width: "7%" }} align="center" />
        <Column
          body={(rowData) => (
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-outlined p-button-danger"
              onClick={() => handleDeleteChart(rowData)}
            />
          )}
          style={{ width: "3%" }}
        />
      </DataTable>
    </div>
  );
};

export default DataTableComponent;
